<template>
  <div class="body">
    <div class="header">
      <a class="logo" href="javascript:;" @click="$router.push({path:'/'})">
        <img src="../assets/img/logo.svg" alt/>
      </a>
      <!-- <a class="menu_btn" href="javascript:;" @click="$router.push('more')">
        <img src="../assets/img/menu.png" alt/>
      </a> -->
    </div>
    <div class="box"></div>
    <div class="notice">
      <img src="../assets/img/icon_notice.png" alt="">
      <span>请凭本人的签到二维码至会议签到处签到，领取参会证后方可进出会场！</span>
    </div>
    <div class="title-bj">
      <div class="title">{{ model.title }}</div>
      <div class="priceBox">
        <span
          class="span"
        >会议时间：{{
            model.startTime.slice(0, model.startTime.length - 8)
          }} ~ {{ model.endTime.slice(0, model.endTime.length - 8) }}</span>
        <span class="span">地点：{{ model.region }}</span>
      </div>
      <div>签到二维码</div>
    </div>
    <div class="sign">
			<div v-if="signList.length > 1 && !$route.query.isMealSign" class="person">
				<select v-model="selected">
					<option v-for="item in signList" :value="item.id">{{item.name}}</option>
				</select>
			</div>
      <div class="detail">
        <div class="item" style="justify-content: space-between;">
          <div>
            <img src="../assets/img/icon_per.png" alt="" style="padding-right: 6px;">
            <span>参会人：{{ selData.name }}</span>
          </div>
          <div class="stamp">{{ selData.enrollTicketName }}</div>
        </div>
        <div class="item">
          <img src="../assets/img/icon_com.png" alt="">
          <span>公司：{{ selData.enName }}</span>
        </div>
        <div class="item">
          <img src="../assets/img/icon_tel.png" alt="">
          <span>手机号码：{{ selData.phone }}</span>
        </div>
      </div>
			<div class="success-time">{{currentTime}}</div>
			<span v-if="!$route.query.isMealSign">
				<div v-if="selData.qrCodeResponseType == 0" class="img">
				  <img :src="selData.ticketUrl" alt="">
					<div v-if="selData.signStatus == 1">已签到</div>
				</div>
				<div v-else class="success-img">
					<div v-if="selData.qrCodeResponseStatus == 1">
						<img src="../assets/svg/success.svg" alt="">
						<div v-if="selData.qrCodeResponseType == 1">签到成功！</div>
						<div v-else-if="selData.qrCodeResponseType == 2">入场成功！</div>
						<div v-else-if="selData.qrCodeResponseType == 3">核销成功！</div>

						<span class="error-note" v-if="selData.qrCodeResponseType == 1">您已签到成功，请领取会议资料并入场！</span>
						<span class="error-note" v-else-if="selData.qrCodeResponseType == 2">欢迎来到“{{model.title}}”<span>{{sessionName}}</span>！</span>
					</div>
					<div v-if="selData.qrCodeResponseStatus == 0">
						<img src="../assets/svg/error_new.svg" alt="">
						<div v-if="selData.qrCodeResponseType == 1">签到失败！</div>
						<div v-else-if="selData.qrCodeResponseType == 2">入场失败！</div>
						<div v-else-if="selData.qrCodeResponseType == 3">核销失败！</div>

						<span class="error-note">{{selData.qrCodeResponseNote}}</span>
					</div>
				</div>
			</span>
			<span v-else>
				<div class="success-img">
					<div v-if="mealMessage.length == 0">
						<span v-if="mealSuccess">
							<img src="../assets/svg/success.svg" alt="">
							<div>核销成功！</div>
						</span>
					</div>
					<div v-else>
						<img src="../assets/svg/error_new.svg" alt="">
						<div class="success-time" style="font-size: 16px;">{{mealMessage}}</div>
					</div>
				</div>
			</span>
    </div>
  </div>
</template>
<script>
export default {
  data () {
    return {
      model: {
        startTime: '',
        endTime: ''
      },
      interval: null,
      intervals: null,
      showCode: true,
      hideSession: false,
      mealSuccess: false,
      mealMessage: '',
      selected: '',
      signList: [],
      selIndex: 0,
      selData: {
        name: '',
        enrollTicketName: '',
        enName: '',
        phone: '',
        sessionName: '',
        countSigned: 0
      },
      sessionName: '',
      mealCount: 0,
      currentTime: ''
    }
  },
  watch: {
    selected (key) {
      this.selIndex = (this.signList || []).findIndex((item) => item.id === key)
      this.showCode = true
      this.hideSession = false

      if (!this.$route.query.isMealSign) {
        clearInterval(this.interval)
        this.interval = setInterval(this.getSignQRCode, 2000)
        this.$axios.post(`/api/web/phone/conference/resetSessionSign?attendeeId=${this.selected}`).then(res => {})
      } else {
        // if (key != this.selData.id) {
        // 	this.mealCount = 0;
        // 	this.mealAttendee()
        // }
      }
    }
  },
  created () {
    this.content()
    this.showTime()
    setInterval(this.showTime, 1000)
  },
  methods: {
    content () {
      this.$axios
        .post(`api/web/phone/content/detail/${this.$route.query.contentId}`, {})
        .then(res => {
          if (res.code == 200) {
            this.model = res.data

            if (this.$route.query.isMealSign) {
              this.mealAttendee()
            }

            this.getSignQRCode()
            this.interval = setInterval(this.getSignQRCode, 2000)
          }
        })
    },
    getSignQRCode () {
      const param = {
			  conferenceId: this.$route.query.contentId,
			  phoneNumber: this.$route.query.phoneNumber
      }
      this.$axios.post('/api/web/phone/conference/getSignQRCode', param).then(res => {
        if (res.code == 200) {
          this.signList = res.data
          this.selected = this.signList[this.selIndex].id
          this.selData = this.signList[this.selIndex]
          if (this.selData.qrCodeResponseStatus == 1) {
            clearInterval(this.interval)
            this.goSuccess()
          }
        }
      })
    },
    mealAttendee () {
      const param = Object.assign(JSON.parse(this.$route.query.data), {
			  conferenceId: this.$route.query.contentId,
			  phoneNumber: this.$route.query.phoneNumber
      })
      this.$axios.post('/api/web/phone/conference/mealAttendee', param).then(res => {
        if (res.code == 200) {
          this.signList = res.data

          this.selIndex = this.signList.findIndex(elem => elem.id == this.$route.query.id)
          this.selected = this.signList[this.selIndex].id
          this.selData = this.signList[this.selIndex]

          // type 0:午餐 1:晚餐 2:晚宴 3:招待晚宴 4:校友晚宴
          if (this.mealCount == 0) {
            this.$axios.postJson('/api/web/phone/conference/checkMealAttendee', {
              attendeeId: this.selData.id,
              conferenceId: param.conferenceId,
              type: param.type
            }).then(res => {
              if (res.code == 200) {
                this.mealMessage = ''
                this.mealSuccess = true
              } else {
                this.mealMessage = res.message
                // this.MessageBox.alert(res.message).then(action => {});
              }
            })
          }
          this.mealCount++
        }
      })
    },
    goSuccess () {
      // 分论坛 isSession = 1
      if (this.selData.isSession && this.selData.isSession == 1) {
        this.$axios
          .get(`api/web/phone/conference/sessionInfo?sessionId=${this.selData.signSessionId}&attendeeId=${this.selData.id}`, {})
          .then(res => {
            if (res.code == 200) {
              this.sessionName = res.data.sessionName
              this.selData.countSigned = res.data.countSigned
            }
          })
      }
    },
    showTime () {
      var date = new Date()
      var year = date.getFullYear()
      var month = date.getMonth() + 1 // 因为month属性从0开始所以加1
      var day = date.getDate() // 日
      var week = date.getDay() // 星期几，是个数字
      var hour = date.getHours()
      var minute = date.getMinutes()
      var second = date.getSeconds()
      month = month < 10 ? '0' + month : month
      day = day < 10 ? '0' + day : day
      hour = hour < 10 ? '0' + hour : hour
      minute = minute < 10 ? '0' + minute : minute
      second = second < 10 ? '0' + second : second
      var weekStr = ['一', '二', '三', '四', '五', '六', '日']
      var current = month + '月' + day + '日' + ' ' + hour + ':' + minute + ':' + second
      this.currentTime = current
    }
  },
  destroyed () {
    if (this.interval != null) { clearInterval(this.interval) }
  }
}
</script>

<style lang="scss" scoped>
@import "../assets/sass/global.scss";
</style>
<style lang="scss" scoped>
.tip {
  font-size: 12px;
  color: #9f9f9f;
  margin: 20px 24px;
  text-align: left;
}

.priceBox {
  position: relative;
}

.TicketPrice {
  position: absolute;
  font-size: 12px;
  top: 0;
  right: 0;
}

.title-bj {
  padding: 26px;
  margin: 0 12px 0;
  min-height: 68px;
  background: url("../assets/img/dingdan_bg@3x.png");
  background-size: 100% 100%;
  position: relative;

  div:nth-child(3) {
    color: #9f9f9f;
    text-align: left;
    padding-top: 10px;
    font-size: 12px;
  }
}

.span {
  text-align: left;
  font-size: 12px;
  display: block;
  margin-top: 8px;
}

.title {
  text-align: left;
  font-weight: 700;
  font-size: 16px;
}

.notice {
  margin: 22px 12px 0;

  img {
    width: 12px;
    height: 12px;
    padding-right: 2px;
  }

  span {
    color: #9f9f9f;
    font-size: 12px;
  }
}

.sign {
  // height: 100% ;
  background: #fff;
  border-radius: 10px;
  z-index: -1;
  margin: -40px 40px 0;
  padding: 50px 12px 24px;

  .detail {
    font-size: 14px;
    border-bottom: 1px dashed #c0c0c0;
    padding-bottom: 24px;
    margin-bottom: 24px;

    .item {
      text-align: left;
      display: flex;
      margin-bottom: 10px;

      img {
        width: 12px;
        height: 12px;
        padding-right: 10px;
        margin-top: 5px;
      }

      .stamp {
        margin-top: 2px;
        text-align: right;
        color: #FA742B;
        border-radius: 3px;
        border: 1px solid #FA742B;
        font-size: 12px;
      }
    }
  }

	.person {
		text-align: left;
		margin-bottom: 12px;

		select {
			min-width: 90px;
			border-radius: 4px;
			color: #222;
			font-weight: 600;
			border: thin solid #d8d8d8;
			display: inline-block;
			line-height: 1.5em;
			padding: 4px 8px;

			margin: 0;
			-webkit-box-sizing: border-box;
			-moz-box-sizing: border-box;
			box-sizing: border-box;
			-webkit-appearance: none;
			-moz-appearance: none;

			background:url('../assets/svg/down.svg') no-repeat right center;
			background-size: 18px;
			background-position: calc(100% - 10px);
		}
		select:focus {
			background:url('../assets/svg/up.svg') no-repeat right center;
			background-size: 18px;
			background-position: calc(100% - 10px);
			border-color: #26a2ff;
			outline: 0;
		}
	}

  .img {
    img {
      width: 50%;
      border-radius: 10px;
    }
		div {
			margin-top: 15px;
			color: #71c4f1;
			font-size: 12px;
		}
  }

	.success-img {
		margin-top: 10px;
		img {
		  width: 55%;
			margin: 5px 0;
		  border-radius: 10px;
		}
		div div:nth-child(2) {
		  font-weight: bold;
		  font-size: 14px;
		  margin-top: 10px;
		}
		.session {
			color: #71c4f1;
			font-size: 12px;
			text-decoration: underline;
		}
		.error-note {
			font-size: 12px;
			font-weight: 400;
			color: #9f9f9f;
			margin-top: 15px;
			display: block;
		}
	}

	.success-time {
		font-weight: bold;
		font-size: 24px;
	}
}

/* 使用webkit内核的浏览器 */
::-webkit-input-placeholder {
  color: #9f9f9f;
  line-height: normal;
  padding-top: 0.06rem;
}

/* Firefox版本4-18 */
:-moz-placeholder {
  color: #9f9f9f;
  padding-top: 0.06rem;
}

/* Firefox版本19+ */
::-moz-placeholder {
  color: #9f9f9f;
  padding-top: 0.06rem;
}

/* IE浏览器 */
:-ms-input-placeholder {
  color: #9f9f9f;
  padding-top: 0.06rem;
}

.p {
  margin: 9px 10px 0;
  font-size: 12px;
}

.box {
  height: 56px;
}

.body {
  position: fixed;
  width: 100%;
  height: 100%;
	overflow: scroll;
  // background-color: #fff;
}

.header {
  height: 54px;
  background: #ffffff;
  border-bottom: 2px solid #f5f5f5;
  top: 0;
  left: 0;
  right: 0;
  position: fixed;
  z-index: 99;

  .logo {
    display: inline-block;
    // width: 133px;
    // height: 38px;
    position: absolute;
    top: 10px;
    left: 15px;

    img{
      height: 35px;
    }
  }

  .menu_btn {
    display: inline-block;
    position: absolute;
    top: 13px;
    right: 13px;
    width: 29px;
    height: 29px;
    -webkit-tap-highlight-color: transparent;

    img {
      width: 100%;
      height: 100%;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/signinCode.vue